import React, { Component } from "react";

export default class Portrait extends Component {
  state = {
    currentIndex: 0,
    width: window.innerWidth,
    height: window.innerHeight,
  };

  componentDidMount() {
    const todayBirthdays = this.getTodayBirthdays();
    const duration = (this.props.widget?.data?.duration || 10) * 1000;

    if (todayBirthdays.length > 1) {
      this.interval = setInterval(() => {
        this.setState((prevState) => ({
          currentIndex: (prevState.currentIndex + 1) % todayBirthdays.length,
        }));
      }, duration);
    }
  }

  componentWillUnmount() {
    if (this.interval) clearInterval(this.interval);
  }

  getTodayBirthdays = () => {
    const birthdays = this.props.widget?.data?.birthdays || [];
    const today = new Date();
    const todayMonth = today.getMonth() + 1;
    const todayDate = today.getDate();

    return birthdays.filter((b) => {
      const dob = new Date(b.dob);
      return dob.getMonth() + 1 === todayMonth && dob.getDate() === todayDate;
    });
  };

  render() {
    const widget = this.props.widget;
    const todayBirthdays = this.getTodayBirthdays();
    const { currentIndex } = this.state;
    const width = window.innerWidth;
    const height = window.innerHeight;

    // Reference design dimensions for portrait: 720x1280
    const refWidth = 720;
    const refHeight = 1280;
    const scaleX = width / refWidth;
    const scaleY = height / refHeight;
    const scale = Math.min(scaleX, scaleY);

    // Calculate responsive sizes
    const baseSize = Math.min(width, height);
    const happyBirthdayFontSize = 80 * scale * 1.45; // Increased
    const nameFontSize = baseSize * 0.08; // Slightly reduced for wrapping
    const roleFontSize = baseSize * 0.036; // Increased
    const nameBadgePaddingVertical = baseSize * 0.025;
    const nameBadgePaddingHorizontal = baseSize * 0.06;
    const roleBadgePaddingVertical = baseSize * 0.012;
    const roleBadgePaddingHorizontal = baseSize * 0.025;
    const nameBadgeRadius = baseSize * 0.015; // rounded-lg
    const spacingBetween = height * 0.025;

    return (
      <div
        style={{
          width: width + "px",
        }}
      >
        <div
          className="d-flex justify-content-center align-items-center m-0 p-0 h-100"
          style={{
            width: width + "px",
            height: height + "px",
            background:
              "linear-gradient(135deg, #1E3A8A 0%, #1E40AF 50%, #2563EB 100%)",
            backgroundSize: "100% 100%",
            backgroundRepeat: "no-repeat",
            fontFamily: widget?.data?.fontFamily || "Inter",
            overflow: "hidden",
            position: "relative",
          }}
        >
          {/* Left Balloons - Normal */}
          <img
            src="/images/birthday/balloon.png"
            alt="balloons"
            style={{
              position: "absolute",
              left: "0",
              bottom: "0",
              height: height * 0.45 + "px",
              width: "auto",
              objectFit: "contain",
              pointerEvents: "none",
              zIndex: 1,
            }}
          />

          {/* Right Balloons - Horizontally Flipped */}
          <img
            src="/images/birthday/balloon.png"
            alt="balloons"
            style={{
              position: "absolute",
              right: "0",
              bottom: "0",
              height: height * 0.45 + "px",
              width: "auto",
              objectFit: "contain",
              transform: "scaleX(-1)",
              pointerEvents: "none",
              zIndex: 1,
            }}
          />
          {todayBirthdays.length > 0 ? (
            <div
              className="d-flex flex-column justify-content-flex-start align-items-center w-100"
              style={{
                height: height + "px",
                width: "100%",
                maxWidth: width * 0.9 + "px",
                textAlign: "center",
                paddingTop: height * 0.15 + "px", // Shift content upward
                paddingLeft: height * 0.05 + "px",
                paddingRight: height * 0.05 + "px",
                position: "relative",
                zIndex: 2,
              }}
            >
              {/* HAPPY BIRTHDAY Text */}
              <div
                key={`happy-birthday-${currentIndex}`}
                style={{
                  fontSize: happyBirthdayFontSize + "px",
                  fontWeight: "900",
                  fontStyle: "italic",
                  color: "#FDC700",
                  lineHeight: happyBirthdayFontSize + "px",
                  letterSpacing: "0px",
                  marginBottom: spacingBetween + "px",
                  textTransform: "uppercase",
                  textAlign: "center",
                  animation: "fadeIn 1s ease-in",
                  fontFamily: "Inter, sans-serif",
                }}
              >
                HAPPY
                <br />
                BIRTHDAY
              </div>

              {/* Name Badge - White with rounded-lg */}
              <div
                key={`name-${currentIndex}`}
                style={{
                  backgroundColor: "#FFFFFF",
                  color: "#000000",
                  fontSize: nameFontSize + "px",
                  fontWeight: widget?.data?.fontBold ? "900" : "bold",
                  paddingTop: nameBadgePaddingVertical + "px",
                  paddingBottom: nameBadgePaddingVertical + "px",
                  paddingLeft: nameBadgePaddingHorizontal + "px",
                  paddingRight: nameBadgePaddingHorizontal + "px",
                  borderRadius: nameBadgeRadius + "px", // rounded-lg
                  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
                  marginBottom: spacingBetween + "px",
                  wordBreak: "break-word", // Allow word wrapping
                  maxWidth: width * 0.8 + "px",
                  animation: "fadeIn 0.5s ease-in",
                  display: "block",
                  fontFamily: widget?.data?.fontFamily || "Arial",
                }}
              >
                {todayBirthdays[currentIndex].name || "John Doe"}
              </div>

              {/* Role Badge - Yellow with rounded-pill */}
              {todayBirthdays[currentIndex].role && (
                <div
                  key={`role-${currentIndex}`}
                  style={{
                    backgroundColor: "#FDC700",
                    color: "#000000",
                    fontSize: roleFontSize + "px",
                    fontWeight: widget?.data?.fontBold ? "900" : "bold",
                    paddingTop: roleBadgePaddingVertical + "px",
                    paddingBottom: roleBadgePaddingVertical + "px",
                    paddingLeft: roleBadgePaddingHorizontal + "px",
                    paddingRight: roleBadgePaddingHorizontal + "px",
                    borderRadius: "9999px", // rounded-pill (very high border radius)
                    textTransform: "uppercase",
                    wordBreak: "break-word",
                    maxWidth: width * 0.7 + "px",
                    animation: "fadeIn 0.5s ease-in",
                    display: "inline-block",
                    fontFamily: widget?.data?.fontFamily || "Arial",
                  }}
                >
                  {todayBirthdays[currentIndex].role}
                </div>
              )}
            </div>
          ) : (
            <div
              className="d-flex flex-column justify-content-center align-items-center w-100"
              style={{
                height: height + "px",
                width: "100%",
                maxWidth: width * 0.9 + "px",
                textAlign: "center",
                padding: height * 0.05 + "px",
                position: "relative",
                zIndex: 2,
                fontFamily: widget?.data?.fontFamily || "Arial",
              }}
            >
              <div
                style={{
                  fontSize: baseSize * 0.08 + "px",
                  textAlign: "center",
                  color: "#FFFFFF",
                  fontWeight: "bold",
                  fontFamily: widget?.data?.fontFamily || "Arial",
                }}
              >
                No birthdays today
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}
